import classNames from 'classnames';

import { DescribedIssue } from '../../issues';
import { Selection } from '../../selection';

interface IssueListProps {
  issues: DescribedIssue[];
  onSelect?: (target: Selection) => void;
}

const IssueList = ({ issues, onSelect }: IssueListProps) => (
  <ul className="grid gap-1">
    {issues.map(({ label, target }, index) => (
      <li key={`${label}-${index}`}>
        <button
          type="button"
          disabled={!onSelect}
          onClick={() => onSelect?.(target)}
          className={classNames(
            'w-full flex items-center gap-3 px-2 py-1.5 rounded-lg text-left text-sm text-neutral-80',
            { 'hover:bg-danger-10': onSelect },
          )}
        >
          <span className="flex items-center justify-center w-4 h-4 rounded-full border-2 border-danger-50 text-danger-50 text-[10px] font-bold">
            !
          </span>
          <span className="flex-1">{label}</span>
          {onSelect && <span className="text-neutral-40">›</span>}
        </button>
      </li>
    ))}
  </ul>
);

export default IssueList;
